import React from 'react';
import BodyContainer from '../bodyContainer/BodyContainer';
import {TextArea } from 'cdk-radial';
import { InputChips,Input } from 'cdk-radial';
import './styles/reviewSubscriptions.scss';
import ReviewSubsSummaryCard from './ReviewSubscriptionCard';
import AuthComponent from '../../../../components/common/AuthComponent';
import { connect } from 'react-redux';

const GMAIl_DOMAIN = 'gmail.com';
const HOTMAIL_DOMAIN = 'hotmail.com';
const YAHOO_DOMAIN = 'yahoo.com'

class ReviewSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userComment : props.reviewSubscriptionSlice.userComment || '',
      emails:props.reviewSubscriptionSlice.emailsForSubscriptionNotifications || [],
      emailInputErrorMessage:'Email already exists',
      emailInputHasError: false,
      enableEmailInputCustomValidation:false,
      emailInputValue: ''
    };
    this.emailInputRef = React.createRef();
  }

  handleEmailsSelect = (emails) => {
    let oldEmailsArr = Array.from(this.state.emails);

    if(emails.length > oldEmailsArr.length){
      // A new email string is been added.
      let emailObj = {};
      for(let email of emails){
        emailObj[email] = 1;
      }
      for(let email of oldEmailsArr){
        if(emailObj[email]){
          delete emailObj[email];
        }
      }

      

      let newEmail = '';
      let newEmailsArr = Object.keys(emailObj)

      if(newEmailsArr.length === 1){
        newEmail = newEmailsArr[0];
      }

      let originalEmailAddress = newEmail;

      //making the email to it's lowercase.
      for(let i=0; i < emails.length; i++){
        if(emails[i] === newEmail){
          emails[i] = newEmail.toLowerCase();
          newEmail = emails[i];
        }
      }

      let isEmailStringValidated = this.validateEmail(newEmail);
      let isEmailDomainValidated = this.validateDomainOfEmail(newEmail);

      if(isEmailStringValidated && isEmailDomainValidated){
        this.setState({
          enableEmailInputCustomValidation: false,
          emailInputErrorMessage:'Email already exists',
          emailInputHasError: false,
          emailInputValue:'',
          emails
        });
      } else {
        if(!isEmailStringValidated){
          this.setState({
            enableEmailInputCustomValidation: true,
            emailInputErrorMessage:"Enter valid email address",
            emailInputHasError: true,
            emailInputValue: newEmail
          },()=>{
            this.emailInputRef.current.value = originalEmailAddress;
          });
        }
        if(!isEmailDomainValidated){
          this.setState({
            enableEmailInputCustomValidation: true,
            emailInputErrorMessage:"emails from this domain are not supported",
            emailInputHasError: true,
            emailInputValue: newEmail
          },()=>{
            this.emailInputRef.current.value = originalEmailAddress;
          });
        }
      }
    } else {
      this.setState({emails});
    }
   
  }

  validateDomainOfEmail = (email) => {
    let unallowedDomains = [GMAIl_DOMAIN,HOTMAIL_DOMAIN,YAHOO_DOMAIN];
    for( let domain of unallowedDomains){
      let re = new RegExp("^[A-Za-z0-9._%+-]+@"+domain+"$");
      if(re.test(email)){
        //this indicates that the email contain one of the unallowed domain..
        //so returning false in this case
        return false;
      }
    }
    //not matched with any of the unallowed domains then return true.
    return true;
  }

  validateEmail = (email) => {
    let re = /[a-z0-9!#$%&‘*+\=?^_`{|}~-]+(?:\.[a-z0-9!#$%&‘*+\=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(email);
  }

  render() {
    return (
      <BodyContainer title={this.props.constants.REVIEW_TITLE} description={this.props.constants.REVIEW_DESCRIPTION}>
        <div className="solution-review">
          <div className="solution-review-summary">
            <div className="solution-review-summaryTitle">
              {this.props.constants.SUMMARY}
            </div>
            <ReviewSubsSummaryCard installNote={this.state.userComment} emailsForSubscriptionNotifications={this.state.emails}/>
          </div>
          <div className="solution-review-emails-input">
            <InputChips inputProps={{
              errorMessage: this.state.emailInputErrorMessage,
              id: 'emails-input',
              label: 'Email',
              name: 'email-input',
              placeholder: this.props.constants.SHARE_EMAIL_HELPER_TEXT,
              type: 'email',
              enableCustomValidation: this.state.enableEmailInputCustomValidation,
              hasError: this.state.emailInputHasError,
              value: this.state.emailInputValue,
              ref: this.emailInputRef,
              onBlur: () =>{
                this.setState({
                  enableEmailInputCustomValidation: false,
                  emailInputErrorMessage:'Email already exists',
                  emailInputHasError: false
                })
              },
              className:'email-input-chip-set-input'
            }} className="email-input-chip-set" onChange={this.handleEmailsSelect} options={this.state.emails} />
          </div>
          <div className="solution-review-notes">
            <TextArea
              className="solution-review-notes-textArea"
              id="text-area"
              label="Installation Notes/Questions (Optional)"
              maxLength='-'
              name="text-area"
              placeholder="Let us know if there are any intallation questions or instructions and our team will get back to you."
              value={this.state.userComment}
              onChange={(e)=>this.setState({
                userComment: e.target.value
              })}
            />
          </div>
        </div>
      </BodyContainer>
    );
  }
}

const mapStateToProps = state => ({
  constants:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.constants
});

export default connect(mapStateToProps)(AuthComponent(ReviewSubscription));
